module.exports = __webpack_public_path__ + "static/media/loader.44646966.gif";